module.exports = __webpack_public_path__ + "img/arrowLeftW.1829d10f.svg";